let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("buOJ5")).then(() => parcelRequire('29C6m'));